import React, { useContext } from "react";
import { triggerTealiumEvent } from "../../utils/tealiumUtils";
import { useLocation } from "@reach/router";
import { MenuContext } from "../../context";
import PropTypes from "prop-types";

const LinkCard = ({
  title,
  description,
  linkHref,
  colClass = "col-xs-12 col-xl-3",
  backgroundColor = "",
  theme = "",
  isExternal = true,
  tealiumEventName = "",
  tealiumCategory = "content",
  tealiumAction = "button",
  tealiumLabel = "product information",
  tealiumPage = "Home",
}) => {
  const location = useLocation();
  const menuContext = useContext(MenuContext);

  const handleClick = () => {
    if (tealiumEventName) {
      triggerTealiumEvent(
        "link",
        location.href,
        tealiumCategory,
        tealiumAction,
        tealiumEventName,
        tealiumLabel,
        tealiumPage,
        ""
      );
    }
  };

  const cardStyle = backgroundColor ? { backgroundColor } : {};

  return (
    <div className={colClass}>
      <a
        className={`link-card${theme ? ` link-card--${theme}` : ""}`}
        style={cardStyle}
        href={linkHref}
        target={isExternal ? "_blank" : "_self"}
        rel={isExternal ? "noreferrer" : undefined}
        onClick={handleClick}
        inert={menuContext.isMenuOpen ? "true" : null}
      >
        <h3>{title}</h3>
        {description && <p>{description}</p>}
      </a>
    </div>
  );
};

LinkCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  linkHref: PropTypes.string.isRequired,
  colClass: PropTypes.string,
  backgroundColor: PropTypes.string,
  theme: PropTypes.string,
  isExternal: PropTypes.bool,
  tealiumEventName: PropTypes.string,
  tealiumCategory: PropTypes.string,
  tealiumAction: PropTypes.string,
  tealiumLabel: PropTypes.string,
  tealiumPage: PropTypes.string,
};

export default LinkCard;
